import styled from 'styled-components';

const JobDetailsBlock = styled.div`
  border: 1px solid ${p => p.theme.color.border};
  border-radius: 6px;
  display: flex;
  .column {
    width: 33.333333333333333%;
    box-sizing: border-box;
    display: block;
    border-right: 1px solid ${p => p.theme.color.border};
    &:last-child {
      border-right: none;
    }
  }    
  .column-title {
    font-size: 1.5em;
    margin: 10px 16px;
    &+ .column-row {
      margin-top: 6px;
    }
  }
  .column-row {
    margin: 32px 16px;
    display: flex;
    flex-wrap: wrap;
    &>* {
      width: 100%;
    }
    &.small-margins {
      margin: 16px;
    }
    &.small-margin-bottom {
      margin-bottom: 26px;
    }
  }
  .half-row {
    width: 50%;
    box-sizing: border-box;
    padding-right: .5em;
    &:nth-of-type(even) {
      padding-right: 0; 
    }
  }    
`;

export default { JobDetailsBlock };